<template>
  <v-content>
    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
    <!-- <core-footer v-if="$route.name !== 'Maps' && $route.name !== 'Timesheets'" /> -->
  </v-content>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: process.env.VUE_APP_TITLE//'Pipefish Timesheets'
    }
  }
}
</script>

<style>
#core-view {
  /* padding-bottom: 100px; */
  /* background-color: #ffffff */
  /* max-width: 1200px; */
}

@media screen and (min-width: 991px) {
  #core-view{
    /* margin-right: 30px */
  }
}
</style>
